import React, { useCallback, useMemo } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import { DisplayProvider, Devices } from 'UtilityComponents/displayContext';
import useDeviceDetect from 'UtilityComponents/customeHooks/useDeviceDetect';
import { trackClickEvents } from 'UtilityComponents/Util';
import Header from 'common/LandingHeader/Header';
import Theme from 'common/Theme';
import Footer from 'common/LandingFooter/Footer';
import GlobalStyle from 'common/GlobalStyles/GlobalStyles';
import { AppWrapper } from './templateStyles';

function MiceTemplate({ isLoggedInUser,
	isMobile,
	children,
	headerLinks = [],
	headerConfig } ) {
	const devicedetect = useDeviceDetect();
	const isMobileView = isMobile || devicedetect.isMobile;
	const isLandScape = devicedetect.isLandScape;
	const { pathname } = useLocation();
	const history = useHistory();

	const dispVal = useMemo(()=>({
		isMobile: isMobileView ? Devices.mobile : Devices.desktop,
		isLandScape: isLandScape
	}), [isMobileView, isLandScape]);

	const navClick = useCallback((e) => {
		if (e && e.target && e.target.dataset) {
			const defaultPageUrl = '/mice/';
			const { link = '', pageurl = defaultPageUrl, trackval } = e.target.dataset;
			const compname = link;
			const element = document.getElementById(compname);
			let newLocation = pageurl;
			if (compname) {
				newLocation = newLocation + '#' + compname;
			}
			try {
				if (element) {
					const bodyRect = document.body.getBoundingClientRect();
					const elemRect = element.getBoundingClientRect();
					const elementPosition = elemRect.top - bodyRect.top;
					const headerOffset = 80;
					const offsetPosition = elementPosition - headerOffset;

					window.scrollTo({
						top: offsetPosition,
						behavior: 'smooth'
					});
					history.push(newLocation);
				} else if (pathname === pageurl && compname) {
					!e.scollMore && history.push(newLocation);
				} else {
					window.location = newLocation;
				}
			} catch (error) {
				window.location = newLocation;
			}
			trackClickEvents(trackval);
		}
	}, [pathname, history]);

	const headerConfigData = useMemo(() => ( {
		onNavClick: navClick,
		menuWidth: '800px',
		scrollOffset: 60,
		isLoggedInUser,
		...headerConfig
	}), [navClick, isMobileView]);

	return (
		<ThemeProvider theme={Theme}>
			<DisplayProvider
				value={dispVal}>
				<GlobalStyle />
				<Header
					headerLinks={headerLinks}
					headerConfig={headerConfigData}
				/>
				<AppWrapper>
					{children && React.cloneElement(children, {
						navClick

					})}
				</AppWrapper>
				<Footer />
			</DisplayProvider>
		</ThemeProvider>

	);
}

export default MiceTemplate;
